import { combineReducers } from "redux";
import { reducer } from "./reducer";
import { authReducer } from "./authReducer";

const rootReducer = combineReducers({
  data: reducer,
  auth: authReducer
});

export default rootReducer;
